import classnames from 'classnames';
import React from 'react';
import { ItemList, SearchEntity } from 'v2/models';
import { parseSearchFilter } from 'v2/utils/searchUtils';
import styles from './searchProviderFilterView.module.scss';

interface SearchProviderFilterViewProps {
  filters: SearchEntity['filters'];
  className?: {
    value?: string;
    label?: string;
    filterItem?: string;
  };
}

const SearchProviderFilterView = ({
  filters,
  className,
}: SearchProviderFilterViewProps) => {
  const customStyles = className ?? styles;
  const renderFilterValue = (value: string | string[] | ItemList) => {
    if (Array.isArray(value)) {
      return value.map((item) => (
        <p key={item} className={classnames('mb-1', customStyles.value)}>
          {item}
        </p>
      ));
    }
    return <span className={customStyles.value}>{value}</span>;
  };

  return (
    <ul className="m-0 p-0">
      {filters.map((item) => (
        <li
          key={item.filter.name}
          className={classnames(customStyles.filterItem, 'mb-3')}
        >
          <span className={customStyles.label}>{item.filter.name}</span>
          <div>
            {renderFilterValue(
              parseSearchFilter(item.data.filter_value, item.data.filter_units)
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default SearchProviderFilterView;
